import { render, staticRenderFns } from "./BlocksIcon.vue?vue&type=template&id=b2507264&"
import script from "./BlocksIcon.vue?vue&type=script&lang=js&"
export * from "./BlocksIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports